module.exports = __webpack_public_path__ + "static/media/ministry-of-justice.699131f5.svg";